import React from 'react';

/**
 * Stroke glyphs for the phone bottom nav, listing badges and browse controls.
 * Each is a 24-unit viewBox drawing that takes its colour from the `color`
 * prop and is `aria-hidden`; the element that holds it carries the
 * accessible name.
 */
export interface BrowseGlyphProps {
  /** Glyph size in pixels (default 22). */
  size?: number;
  /** Stroke colour (default `currentColor`). */
  color?: string;
}

const STROKE_WIDTH = 1.6;

const GlyphFrame: React.FC<BrowseGlyphProps & { children: React.ReactNode }> = ({
  size = 22,
  color = 'currentColor',
  children,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={STROKE_WIDTH}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const CompassGlyph: React.FC<BrowseGlyphProps> = (props) => (
  <GlyphFrame {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M16 8L14 14L8 16L10 10L16 8Z" />
  </GlyphFrame>
);

export const DeskBellGlyph: React.FC<BrowseGlyphProps> = (props) => (
  <GlyphFrame {...props}>
    <path d="M4 17C4 12.6 7.6 9 12 9C16.4 9 20 12.6 20 17" />
    <path d="M3 17H21V19.5H3Z" />
    <path d="M12 9V6.5M10 6.5H14" />
  </GlyphFrame>
);

export const PersonGlyph: React.FC<BrowseGlyphProps> = (props) => (
  <GlyphFrame {...props}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21C4 16.6 7.6 13 12 13C16.4 13 20 16.6 20 21" />
  </GlyphFrame>
);

export const HouseGlyph: React.FC<BrowseGlyphProps> = (props) => (
  <GlyphFrame {...props}>
    <path d="M3 11L12 4L21 11V20H14V14H10V20H3V11Z" />
  </GlyphFrame>
);

export const StarGlyph: React.FC<BrowseGlyphProps> = (props) => (
  <GlyphFrame {...props}>
    <path d="M12 2L14.5 8.5L21 9.3L16 14L17.3 20.5L12 17.2L6.7 20.5L8 14L3 9.3L9.5 8.5L12 2Z" />
  </GlyphFrame>
);

export const GiftGlyph: React.FC<BrowseGlyphProps> = (props) => (
  <GlyphFrame {...props}>
    <rect x="3" y="9" width="18" height="11" rx="1.5" />
    <path d="M12 9v11M3 13h18M12 9c-2-4-6-4-6-1.5S10 9 12 9c2 0 6-1 6-1.5S14 5 12 9z" />
  </GlyphFrame>
);
